import styled from 'styled-components'

const MailItemModalStyled = styled.div`
  background-color: ${({ theme }) => theme.color.neutral};
  clip-path: polygon(0 0, 100% 0, 100% 100%, 40px 100%, 0 calc(100% - 40px));
  padding: 25px 35px;
  position: relative;
  color: white;
  width: 600px;
  min-height: 500px;
  max-height: 600px;
  word-wrap: break-word;
  .close-btn {
    position: absolute;
    top: 10px;
    right: 10px;
    background-color: ${({ theme }) => theme.color.transparent};
    border: none;
    z-index: 1;
  }

  .title-mail-item {
    font-size: 30px;
    color: green;
    justify-content: center;
  }

  .content-mail-item {
    a {
      color: white;
      text-decoration: underline;
    }
    
    margin-top: 10px;
    font-size: 20px;
    white-space: pre-line;
    max-height: 400px;
    overflow-y: auto;
  }

  .content-mail-item::-webkit-scrollbar-track {
    border: 1px solid #000;
    padding: 2px 0;
    background-color: #000;
  }

  .content-mail-item::-webkit-scrollbar {
    width: 5px;
  }

  .content-mail-item::-webkit-scrollbar-thumb {
    border-radius: 10px;
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: #2f323e;
    border: 1px solid #000;
  }

  .item-mail-items {
    margin-top: 30px;
    .kuda {
      position: relative;
      width: 70px;
      text-align: center;
      span {
        position: absolute;
        z-index: 1;
        left: 35px;
        top: -12px;
      }
      .game-token-kuda {
        position: absolute;
        height: 18px;
        z-index: 1;
        top: -9px;
        left: 12px;
      }
    }

    .merah {
      position: relative;
      width: 70px;
      text-align: center;
      span {
        position: absolute;
        z-index: 1;
        left: 33px;
        top: -12px;
      }
      .game-token-merah {
        position: absolute;
        width: 20px;
        height: 20px;
        z-index: 1;
        top: -9px;
        left: 15px;
      }
    }
  }

  .claim-content {
    margin-top: 30px;
    button {
      background: #191d2c;
      border: none;
    }
  }
`

export default MailItemModalStyled
